export default class InputStepper {
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.options = { ...InputStepper.prototype.defaults, ...options }
        this.init()
    }

    init() {
        this.DOM.$buttonNeg = this.DOM.$el.querySelector(this.options.selectorButtonNeg)
        this.DOM.$buttonPos = this.DOM.$el.querySelector(this.options.selectorButtonPos)
        this.DOM.$input = this.DOM.$el.querySelector(this.options.selectorInput)

        this.max = parseInt(this.DOM.$input.getAttribute('max'), 10)
        this.min = parseInt(this.DOM.$input.getAttribute('min'), 10)
        this.val = parseInt(this.DOM.$input.value, 10)

        let eventNameClick = 'click'

        if ('ontouchstart' in document.documentElement) {
            eventNameClick = 'touchstart'
        }

        this.DOM.$buttonNeg.addEventListener(eventNameClick, this.onButtonClick.bind(this))
        this.DOM.$buttonPos.addEventListener(eventNameClick, this.onButtonClick.bind(this))
        this.DOM.$input.addEventListener('blur', this.onInputBlur.bind(this))
        this.DOM.$input.addEventListener('change', this.updateStyle.bind(this))
        if (this.DOM.$input.dataset[this.options.dataAttrAdminOrder]) {
            this.DOM.$input.addEventListener('change', this.onInputChange.bind(this))
        }

        this.update()
    }

    onButtonClick(e) {
        e.preventDefault()

        const increment = parseInt(e.currentTarget.dataset[this.options.dataAttrIncrement], 10)

        this.val += increment
        this.update()
    }

    onInputBlur() {
        this.val = parseInt(this.DOM.$input.value, 10)
        this.update()
    }

    update() {
        if (this.val <= this.min) {
            this.val = this.min
            this.DOM.$buttonNeg.disabled = true
        } else {
            this.DOM.$buttonNeg.disabled = false
        }

        if (this.val >= this.max) {
            this.val = this.max
            this.DOM.$buttonPos.disabled = true
        } else {
            this.DOM.$buttonPos.disabled = false
        }

        this.DOM.$input.value = this.val

        this.DOM.$input.dispatchEvent(new Event('change'))
    }

    onInputChange(e) {
        let $extraFields = document.querySelector(this.options.selectorExtraFields + this.DOM.$input.dataset[this.options.dataAttrProductId]);
        let $columns = document.querySelector(this.options.selectorProductRow + this.DOM.$input.dataset[this.options.dataAttrProductId]).querySelectorAll('td');
        if (e.currentTarget.value > 0) {
            $extraFields.classList.remove('u-hide');
            $columns.forEach(element => {
                element.classList.add('c-table__col--product-selected')
                element.querySelector('div').classList.remove('u-m-l')
            });
        } else {
            $extraFields.classList.add('u-hide');
            $columns.forEach(element => {
                element.classList.remove('c-table__col--product-selected')
                element.querySelector('div').classList.add('u-m-l')
            });
        }
    }

    updateStyle(e) {
        if (this.DOM.$input.value.toString().length > 3) {
            // 4 chars or more, remove padding and shrink font size
            this.DOM.$input.style.paddingLeft = "0";
            this.DOM.$input.style.paddingRight = "0";
            this.DOM.$input.classList.add('u-text-s')
        } else if (this.DOM.$input.value.toString().length === 3) {
            // 3 chars, remove padding
            this.DOM.$input.style.paddingLeft = "0";
            this.DOM.$input.style.paddingRight = "0";
            this.DOM.$input.classList.remove('u-text-s')
        } else {
            // Whatever the CSS says
            this.DOM.$input.style.removeProperty('padding-left');
            this.DOM.$input.style.removeProperty('padding-right');
            this.DOM.$input.classList.remove('u-text-s')
        }
    }
}

InputStepper.prototype.defaults = {
    dataAttrIncrement: 'inputStepperIncrement',
    dataAttrAdminOrder: 'inputStepperAdminOrder',
    dataAttrProductId: 'inputStepperProductId',
    selectorButtonNeg: '.js-inputStepperButtonNeg',
    selectorButtonPos: '.js-inputStepperButtonPos',
    selectorInput: '.js-inputStepperInput',
    selectorProductRow: '#js-inputStepperProductRow--',
    selectorExtraFields: '#js-inputStepperExtraFields--',
}